"use client";

import { BSRChevronRight } from "./bsr/BSRChevronRight";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ChevronRight as LegacyChevronRight } from "./legacy/ChevronRight";

export const ChevronRight = createBSRExperimentIcon(
  LegacyChevronRight,
  BSRChevronRight
);
